import { render } from "./NcrmSegmentedControl.vue?vue&type=template&id=08189a64&scoped=true"
import script from "./NcrmSegmentedControl.vue?vue&type=script&lang=js"
export * from "./NcrmSegmentedControl.vue?vue&type=script&lang=js"

import "./NcrmSegmentedControl.vue?vue&type=style&index=0&id=08189a64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08189a64"]])

export default __exports__